var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-container"},_vm._l((_vm.breadCrumbs),function(crumb,index){return _c('div',{key:crumb.title,staticClass:"breadcrumb-item"},[(!crumb.hidden)?_c('p',{class:{
        'breadcrumb-item-active': crumb.active,
        'breadcrumb-item-clickable': !crumb.active && crumb.canNavigate,
        'breadcrumb-item-unclickable': !crumb.active && !crumb.canNavigate,
      },on:{"click":function($event){return _vm.goToRoute(crumb.route, crumb.canNavigate)}}},[_vm._v("\n      "+_vm._s(crumb.title)+"\n    ")]):_vm._e(),_vm._v(" "),(index != _vm.breadCrumbs.length - 1 && !crumb.hidden)?_c('span',[_vm._v(" / ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }